<!-- 
Listing of levy estimator templates.
-->
<template>
  <div>
    <v-card class="v-card--flat">
      <our-simple-table-header
        :total-items="listing.paging.totalItems"
        :has-export="hasExport"
        :has-export-to-json="hasExport"
        @click:refresh="refresh" 
        @click:export="exportToExcel" 
        @click:exportToJson="exportToJson"
      />
      <our-table-busy-indicator :show="listing.loading"/>
      <v-data-table
        :headers="headers" 
        :items="listing.data" 
        :pagination="listing.paging"
        :total-items="listing.paging.totalItems"
        :no-data-text="noDataText"
        must-sort hide-actions
        @click:refresh="refresh" 
        @update:pagination="updatePagination"
      >
        <template slot="items" slot-scope="props">
          <tr @click="$emit('click', props.item.type)">
            <our-nav-col :row="lookups.estimatorTemplateTypeDescriptions[props.item.type]"/>
            <td>{{ lookups.estimatorTemplateTypeDescriptions[props.item.type] }}</td>
            <td>{{ props.item.template }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import * as action from "@/store/estimator-templates/action-types";
import * as mutation from "@/store/estimator-templates/mutation-types";
import tableMixins from "@/mixins/table.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import { ESTIMATOR_TEMPLATES_EXPORT } from "@/store/claim-types";

export default {
  mixins: [tableMixins, lookupMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      action: action.LIST,
      pagingMutation: mutation.LIST_SET_PAGING,
      exportAction: action.EXPORT_SPREADSHEET,
      exportToJsonAction: action.EXPORT_JSON,
      headers: [
        { text: "", value: "Id", class: "navCol", width: 0, sortable: false },
        { text: "Type", value: "Type", sortable: true, width: this.$vuetify.breakpoint.smAndDown ? null : 250 },
        { text: "Template", sortable: false }
      ]
    };
  },
  computed: {
    listing() {
      return this.$store.state.estimatorTemplates.listing;
    },
    loaded() {
      return this.listing.loaded;
    },
    hasExport() {
      return this.$store.getters.claims.includes(ESTIMATOR_TEMPLATES_EXPORT);
    }
  },
  watch: {
    levyCollectionId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      const needsReloaded =
        (!this.listing.loaded && !this.listing.loading) || this.levyCollectionId != this.listing.levyCollectionId;
      if (needsReloaded) {
        this.$store.commit(mutation.LIST_SET_FILTERS, { levyCollectionId: this.levyCollectionId });
        this.populate();
      }
    }
  }
};
</script>
